import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { columnsProjects } from "../../Global Functions/columnsAntd";
// import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import * as XLSX from "xlsx";
import BookingSourceDropdown from "../Manage Projects/dropDown";

const ListProjects = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [projectType, setProjectType] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [enumsProjects, setEnumsProjects] = useState([]);

  const { projects, loading } = useSelector((state) => state.projects);
  const { enumsData } = useSelector((state) => state.enumsData);

  const fetchDetails = useCallback(async (page, limit, status, showLoader = true) => {
    const filteredStatus = status.filter((s) => s !== "declined");
    const projectData = {
      page,
      limit,
      status: filteredStatus,
      is_deleted: false,
      filter: debouncedSearch,
      ...(projectType &&
        !["published", "unpublished"].includes(projectType[0]) &&
        { name_withoutspace: projectType }
      ),
      ...(projectType && !['residential', 'commercial'].includes(projectType) && { status: projectType }),
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(getProjectList(projectData, showLoader));
      if (!showLoader) {
        // toast.success("Projects list refreshed");
      }
    } catch {
      if (!showLoader) {
        // toast.error("Failed to refresh projects list");
      }
    }
  },
    [dispatch, debouncedSearch, projectType, dateRange]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (enumsProjects.length > 0) {
      fetchDetails(
        pagination.current,
        pagination.pageSize,
        enumsProjects,
        false
      );
    }
  }, [
    pagination.current,
    pagination.pageSize,
    debouncedSearch,
    projectType,
    dateRange,
    enumsProjects,
    fetchDetails,
  ]);


  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    if (enumsData?.data?.ProjectStatus) {
      const statusEnums = Object.values(enumsData.data.ProjectStatus).filter(
        (s) => s !== "declined"
      );
      if (statusEnums.length > 0) {
        setEnumsProjects(statusEnums);
        // fetchDetails(pagination.current, pagination.pageSize, statusEnums);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enumsData, dispatch, pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (projects?.total) {
      setPagination((prevData) => ({ ...prevData, total: projects.total }));
    }
  }, [projects]);

  
  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setPagination((prev) => ({ ...prev }));
    }, 1800000);

    return () => clearInterval(interval);
  }, []);


  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize, enumsProjects);
  };

  // const filterHandler = () => {
  //   setPagination((prevData) => ({ ...prevData, current: 1 }));
  //   fetchDetails(1, pagination.pageSize, enumsProjects);
  // };

  const handleDownloadProjectsExcel = async () => {
    try {
      const projectData = {
        page: pagination.current,
        limit: pagination.pageSize,
        status: enumsProjects,
        is_deleted: false,
        filter: searchQuery,
        ...(projectType &&
          !["published", "unpublished"].includes(projectType[0]) &&
          { name_withoutspace: projectType }
        ),
        ...(projectType && !['residential', 'commercial'].includes(projectType) && { status: projectType }),
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };
      const response = await dispatch(getProjectList(projectData, false));
      const rawProjectData = response?.data || projects?.data || [];
      if (!Array.isArray(rawProjectData) || rawProjectData.length === 0) {
        toast.error("No project data available to download");
        return;
      }

      const preparedData = rawProjectData.map((project) => ({
        projectid: project.project_id,
        projectname: project.project_name,
        brandname: project.brand_name,
        constructionstatus: project.construction_status,
        reraid: project.rera_id,
        launchdate: project.launch_date,
        projectType: project.project_type.name_withoutspace,
        status: project.status,
        Address: project.street_address,
      }));

      const worksheet = XLSX.utils.json_to_sheet(preparedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
      XLSX.writeFile(workbook, "projects_data.xlsx");
      toast.success("Download started!");
    } catch (error) {
      toast.error("Failed to download project data");
    }
  };

  return (
    <MainLayout>
      <div className="bookings_table">

        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="Projects List"
              // filterFunction={filterHandler}
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
              onDownloadProject={handleDownloadProjectsExcel}
            />
          </div>
          <div
            style={{
              position: "static",
              marginTop: "-70px",
              marginLeft: "81%",
              marginBottom: "24px",
            }}
          >
            <BookingSourceDropdown
              value={projectType}
              onChange={(e) => setProjectType(e.target.value)}
            />
          </div>

          <div className="custom_table">
            <div style={{ width: "90%" }}>
              <Table
                dataSource={(Array.isArray(projects?.data) && projects.data) || []}
                virtual
                scroll={{ x: 1700, y: 500 }}
                pagination={pagination}
                onChange={handleTableChange}
                loading={loading}
                columns={columnsProjects}
                rowClassName={() => "text-center"}
              />
            </div>
          </div>
        </div>
      </div >

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </MainLayout >
  );
};

export default ListProjects;
